import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/dashboard' }),
  endpoints: (builder) => ({
    getDashboardItems: builder.query({
      query: (searchParams = '') => searchParams
    }),
    getDashboardAccreditation: builder.query({
      query: (searchParams = '') => 'accreditation' + searchParams
    }),
    getDashboardYearlyAttachment: builder.query({
      query: (searchParams = '') => 'yearly_attachments' + searchParams
    }),
    getDashboardMonthlyCompliance: builder.query({
      query: (searchParams = '') => 'monthly_compliance' + searchParams
    }),
    getDashboardMonthlyRisk: builder.query({
      query: (searchParams = '') => 'monthly_risk' + searchParams
    })
  })
})

export const {
  useGetDashboardAccreditationQuery,
  useGetDashboardYearlyAttachmentQuery,
  useGetDashboardMonthlyComplianceQuery,
  useGetDashboardMonthlyRiskQuery,
  useGetDashboardItemsQuery
} = dashboardApi

export { dashboardApi }
